export type U3120EmployeeRateActionsDisabled = {
  addDisabled: boolean;
  modifyDisabled: boolean;
  deleteDisabled: boolean;
};

export function u3120EmployeeRateActionsDisabled(opts: {
  isRead: boolean;
  canViewRates: boolean;
  selectedCount: number;
}): U3120EmployeeRateActionsDisabled {
  const { isRead, canViewRates, selectedCount } = opts;
  return {
    addDisabled: isRead || !canViewRates,
    modifyDisabled: isRead || selectedCount !== 1 || !canViewRates,
    deleteDisabled: isRead || selectedCount === 0 || !canViewRates,
  };
}
